import React, { useEffect } from 'react';
import { func, oneOf } from 'prop-types';
import isEmpty from 'underscore/modules/isEmpty';

import errorIcon from '../../../../assets/images/shared/download-failed-new@3x.png';
import * as styles from './styles/styles.module.scss';
import Modal from '../Modal';
import Button from '../Button';
import LoadingSpinner from '../LoadingSpinner';
import successUpload from '../../../../assets/images/icons/share/filled@2x.png';
import pdfDownload from '../../../../assets/images/icons/share/icon-pdf@2x.png';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const getVariant = variant => {
  switch (variant) {
    case 'saving':
      return {
        element: <LoadingSpinner />,
        text: `${StringConstantsMixin.strings.MAP_CREATOR.SAVING_YOUR_MAP}...`
      };
    case 'error-saving':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING} />,
        text: StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING
      };
    case 'error':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING} />,
        text: StringConstantsMixin.strings.ERROR_OCCURRED
      };
    case 'error-print-expired':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.ERROR_SAVING} />,
        text: StringConstantsMixin.strings.PRINT_PAGE.SESSION_EXPIRED
      };
    case 'error-cannot-route':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_ROUTE} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.CANNOT_ROUTE
      };
    case 'error-routing':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.ERROR_ROUTING} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.ERROR_ROUTING
      };
    case 'error-deleting-map':
      return {
        element: <img src={errorIcon} className={styles.iconImage} alt={StringConstantsMixin.strings.TRACK_DETAIL.ERROR_DELETING} />,
        text: StringConstantsMixin.strings.TRACK_DETAIL.ERROR_DELETING
      };
    case 'loading': {
      return {
        element: <LoadingSpinner />,
        text: StringConstantsMixin.strings.SEARCH.LOADING
      };
    }
    case 'saved':
      return {
        element: <img src={successUpload} className={styles.iconImage} alt={StringConstantsMixin.strings.MAP_CREATOR.MAP_SAVED} />,
        text: `${StringConstantsMixin.strings.MAP_CREATOR.MAP_SAVED}!`
      };
    case 'downloading':
      return {
        element: <LoadingSpinner />,
        text: `${StringConstantsMixin.strings.PRINT_PAGE.CREATING_MAP}...`
      };
    case 'downloaded':
      return {
        element: <img src={pdfDownload} className={styles.pdfImage} alt={StringConstantsMixin.strings.PRINT_PAGE.PDF_DOWNLOADED} />,
        text: `${StringConstantsMixin.strings.PRINT_PAGE.READY_MAP}`
      };
    default:
      return {};
  }
};

const ProgressDialog = ({ updateProgressDialog, variant, downloadLink, openPdf, isMobileWidth }) => {
  const closeModal = () => {
    updateProgressDialog(null);
  };

  useEffect(() => {
    // automatically closes the modal if saved or error
    if (['saved', 'error', 'error-deleting-map'].includes(variant)) {
      setTimeout(() => {
        closeModal();
      }, 2000);
    }
  }, [variant]);

  const { element, text } = getVariant(variant);

  return (
    <Modal handleBackgroundClick={closeModal}>
      <div className={`${!isEmpty(downloadLink) ? `${styles.printContainer} ${isMobileWidth && styles.mobileWidth}` : styles.container}`}>
        {variant === 'downloaded' && (
          <button className={styles.closeButton} onClick={closeModal} type="button" label={StringConstantsMixin.strings.CLOSE} data-testid="close" />
        )}
        {variant === 'downloaded' ? (
          <div className={styles.pdfContainer}>
            {isMobileWidth && element}
            <div className={isMobileWidth ? styles.text : styles.largeText}>{text}</div>
            {!isMobileWidth && element}
          </div>
        ) : (
          <div>
            {element}
            <div className={styles.text}>{text}</div>
          </div>
        )}
        {!isEmpty(downloadLink) && (
          <Button variant="primary" classes={styles.pdfButton} onClick={openPdf}>
            {StringConstantsMixin.strings.PRINT_PAGE.OPEN_PDF}
          </Button>
        )}
      </div>
    </Modal>
  );
};

ProgressDialog.propTypes = {
  variant: oneOf(['saving', 'error', 'error-cannot-route', 'error-routing', 'saved', 'error-deleting-map', 'downloading', 'downloaded']).isRequired,
  updateProgressDialog: func.isRequired
};

export default ProgressDialog;
